import "./LandingPage.css";
import "../components/fonts.css";
import logo from "../assets/logo.png";
import first_image from "../assets/first_landing.png";
import second_image from "../assets/second_landing.png";
import third_image from "../assets/third_landing.png";
import App_store from "../assets/app-store.png";
import Play_store from "../assets/playstore.png";
import Landing_header from "../components/Landing_header.js";
import { Link } from "react-router-dom";

function Landing_page() {
  const playStore =
    "https://play.google.com/store/apps/details?id=com.happer.happer_android&hl=fr&gl=FR";
  const appStore = "https://apps.apple.com/fr/app/happer/id1476051250";

  function goToWebsite(url) {
    window.open(url, "_blank");
  }

  return (
    <>
      <Landing_header />
      <div className="Landing">
        <>
          <img className="Happer_image" src={logo} alt="Happer LOGO" />
          <h1 style={{ fontSize: "48px", marginTop: "0px" }}>Happer</h1>
          <p className="text1">L'appli mode des créateurs de contenu.</p>
          <div className="apple_div">
            <img
              className="left_apple_img"
              onClick={() => goToWebsite(appStore)}
              src={App_store}
              alt="Apple LOGO"
            />
            <img
              className="right_apple_img"
              onClick={() => goToWebsite(playStore)}
              src={Play_store}
              alt="Apple LOGO"
            />
          </div>
          <p className="text2">
            Shopper les articles mode sélectionnés par les créateurs de contenu.
          </p>
          <div className="grid_div">
            <div className="grid_image">
              <img src={first_image} alt="Happer LOGO" />
            </div>
            <div className="text1_div">
              <p className="text3">
                Happer,l'appli mode alimentée par
                <div /> les créateurs de contenu et les passionnés de mode.
              </p>
            </div>
            <div className="text2_div">
              <p className="text4">
                Avec Happer, découvrez les dernières tendances mode et achetez
                des articles sélectionnés par les influenceurs les plus en
                vogue. Happer permet aux consommateurs de rechercher
                quotidiennement l'inspiration auprès d'influenceurs de renom.
                <br />
                <br />
                De plus, notre technologie exclusive offre des cadeaux pour
                l'audience des Influenceurs Happer.
              </p>
            </div>
          </div>
          <div className="grid_div">
            <div className="grid_image">
              <img src={second_image} alt="Happer LOGO" />
            </div>
            <div className="text1_div">
              <p className="text3">Influenceurs</p>
            </div>
            <div className="text2_div">
              <p className="text4">
                Si vous êtes un créateur de contenu, Happer vous permet d'offrir
                des articles mode à votre audience et de gagner de l'argent
                depuis vos outfits partagés. Peu importe votre audience ou votre
                objectif, si vous postez du contenu inspirant que votre public
                achète, Happer contribuera à votre croissance
              </p>
            </div>
          </div>
          <div className="grid_div">
            <div className="grid_image">
              <img src={third_image} alt="Happer LOGO" />
            </div>
            <div className="text1_div">
              <p className="text3">Marques</p>
            </div>
            <div className="text2_div">
              <p className="text4">
                Si vous êtes une marque, les créateurs de contenu offrent à
                votre audience une expérience ciblée et ludique sur Happer, ce
                qui vous permet de bénéficier d'un marketing d'influence
                exclusif et performant Augmentez vos ventes avec Happer.
              </p>
            </div>
          </div>
          <div className="contact_us">
            <Link to="/CGU">
              <p className="contact">CGU</p>
            </Link>
            <Link to="/CGV">
              <p className="contact">CGV</p>
            </Link>
            <Link to="/CONFIDENTIALITE">
              <p className="contact">Politique de confidentialité</p>
            </Link>
          </div>
        </>
      </div>
    </>
  );
}

export default Landing_page;
